import {
  CLEAR_ORDER_VALUES,
  SET_NOTIFICATION_LOCKED_SEAT_DEPARTURE,
  SET_NOTIFICATION_LOCKED_SEAT_RETURN,
  UPDATE_PASSENGERS_DEPARTURE_CREATE_ORDER,
  UPDATE_PASSENGERS_RETURN_CREATE_ORDER,
  UPDATE_SEARCH_BOOKING_VALUES,
  UPDATE_SEGMENTS_DEPARTURE_CREATE_ORDER,
  UPDATE_SEGMENTS_RETURN_CREATE_ORDER,
} from "../types";
import _ from "lodash";

const INIT_STATE = {
  searchValues: {
    date: "",
    roundtrip: true,
    return_date: "",
    pax: 1,
    selectedSeat: [],
    route_id: null,
    customer: null,
    passengers: [],
    notes: "",
    customer_id: null,
  },
  departure: {
    // passengers_departure: [],
    selectedSeat_departure: [],
    segments: [
      {
        segment_id: null,
        date: "",
        seat: null,
        qty: null,
        price: null,
      },
    ],
    seatRealTimeLocked: [],
  },
  return: {
    // passengers_return: [],
    selectedSeat_return: [],
    segments: [
      {
        segment_id: null,
        date: "",
        seat: null,
        qty: null,
        price: null,
      },
    ],
    returnSeatRealTimeLocked: [],
  },
};

export const bookingReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_BOOKING_VALUES: {
      let stateClone = _.cloneDeep(state);
      _.assign(stateClone.searchValues, action.payload);
      return stateClone;
    }

    case UPDATE_PASSENGERS_DEPARTURE_CREATE_ORDER: {
      let stateClone = _.cloneDeep(state);
      _.assign(stateClone.departure, action.payload);
      return stateClone;
    }

    case UPDATE_PASSENGERS_RETURN_CREATE_ORDER: {
      let stateClone = _.cloneDeep(state);
      _.assign(stateClone.return, action.payload);
      return stateClone;
    }

    case UPDATE_SEGMENTS_DEPARTURE_CREATE_ORDER: {
      let stateClone = _.cloneDeep(state);
      _.assign(stateClone.departure, action.payload);
      return stateClone;
    }

    case UPDATE_SEGMENTS_RETURN_CREATE_ORDER: {
      let stateClone = _.cloneDeep(state);
      _.assign(stateClone.return, action.payload);
      return stateClone;
    }
    case SET_NOTIFICATION_LOCKED_SEAT_DEPARTURE: {
      let stateClone = _.cloneDeep(state);
      let oldSeatRealTimeLocked;
      let mergeTwoArray;
      if (stateClone?.departure?.seatRealTimeLocked?.length > 0) {
        oldSeatRealTimeLocked = stateClone.departure.seatRealTimeLocked;
        mergeTwoArray = _.concat(
          oldSeatRealTimeLocked,
          action.payload.seatRealTimeLocked
        );
      } else {
        mergeTwoArray = action.payload.seatRealTimeLocked;
      }

      _.assign(stateClone.departure, { seatRealTimeLocked: mergeTwoArray });
      return stateClone;
    }

    case SET_NOTIFICATION_LOCKED_SEAT_RETURN: {
      let stateClone = _.cloneDeep(state);
      let oldSeatReturnRealTimeLocked;
      let mergeTwoArray;
      if (stateClone?.return?.returnSeatRealTimeLocked?.length > 0) {
        oldSeatReturnRealTimeLocked =
          stateClone.return.returnSeatRealTimeLocked;
        mergeTwoArray = _.concat(
          oldSeatReturnRealTimeLocked,
          action.payload.returnSeatRealTimeLocked
        );
      } else {
        mergeTwoArray = action.payload.returnSeatRealTimeLocked;
      }

      _.assign(stateClone.return, {
        returnSeatRealTimeLocked: mergeTwoArray,
      });
      return stateClone;
    }

    case CLEAR_ORDER_VALUES: {
      return {
        searchValues: {
          date: "",
          roundtrip: false,
          return_date: "",
          // pax: 1,
          selectedSeat: [],
          route_id: null,
        },
        departure: {
          passengers_departure: [],
          segments: [
            {
              segment_id: null,
              date: "",
              seat: null,
              qty: null,
              price: null,
            },
          ],
        },
        return: {
          passengers_return: [],
          segments: [
            {
              segment_id: null,
              date: "",
              seat: null,
              qty: null,
              price: null,
            },
          ],
        },
      };
    }

    default:
      return state;
  }
};
